// Этап 63: компонент-контроллер фоновой музыки меню. Рендерит null, только
// дёргает менеджер music.ts по роуту/жесту/видимости. Монтируется один раз в App
// (внутри Router — использует useLocation).

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setMenuActive, setMusicVolume, setAppVisible, unlockAudio } from './music';
import { unlockSfx } from './sfx';

// Боевые экраны — музыку меню глушим (у боя своя атмосфера / будущие звуки боя).
const BATTLE_PATHS = ['/battle', '/pvp/battle', '/sandbox', '/tutorial-battle', '/colyseus-test'];

export function MenuMusic() {
  const loc = useLocation();

  // Первый жест юзера разблокирует автоплей (TMA/браузер не дают играть до клика).
  useEffect(() => {
    const unlock = () => { unlockAudio(); unlockSfx(); };
    window.addEventListener('pointerdown', unlock, { once: true });
    window.addEventListener('keydown', unlock, { once: true });
    return () => {
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    };
  }, []);

  // Синхронизация громкости музыки при монтировании (ползунок corps.musicVolume).
  useEffect(() => {
    try {
      const v = localStorage.getItem('corps.musicVolume'); // 0..100
      const vol = v != null && v !== '' ? Number(v) / 100
        : (localStorage.getItem('corps.music') !== '0' ? 0.3 : 0); // миграция со старого тогла
      setMusicVolume(vol);
    } catch { /* ignore */ }
  }, []);

  // Глушим музыку, когда Mini App свёрнут.
  useEffect(() => {
    const onVis = () => setAppVisible(!document.hidden);
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, []);

  // Музыка на всех экранах, кроме боя.
  useEffect(() => {
    const inBattle = BATTLE_PATHS.some(
      (p) => loc.pathname === p || loc.pathname.startsWith(p + '/')
    );
    setMenuActive(!inBattle);
  }, [loc.pathname]);

  return null;
}
